import React from "react";
import "./NetworkError.scss";

type Props = {
  onRetrySoft?: () => void; // ✅ retry request only
  onReload?: () => void;   // ✅ reload whole page
};

function NetworkErrorScreen({ onRetrySoft, onReload }: Props) {
  return (
    <div className="network-error">
      <div className="network-error__card">
        <img
          src="/logo192.jpg"
          alt="Mhiri Store Logo"
          className="network-error__logo"
        />

        <h2 className="network-error__title">Network Error</h2>
        <p className="network-error__desc">
          Connection failed. Please check your internet or server status.
        </p>

        <div className="network-error__actions">
          <button className="btn-retry" onClick={onRetrySoft}>
            Try again
          </button>

          <button className="btn-reload" onClick={onReload}>
            Reload page
          </button>
        </div>
      </div>
    </div>
  );
}

export default NetworkErrorScreen;
